export const ANALYST_ROUTES = {
  DASHBOARD: '/assessments/dashboard',
  ASSESSMENTS: '/assessments/all',
  ASSESSMENTS_GROUP: '/assessments/group-analysis',
  ASSESSMENTS_VIEW: '/assessments/:id/results',
  PEOPLE: '/assessments/people',
  COMPANIES: '/assessments/companies',
  COMPANIES_VIEW: '/assessments/companies/:companyId',
  GROUPS: '/assessments/groups',
  GROUPS_VIEW: '/assessments/groups/:listId',
  PROFILE: '/assessments/account',

  UNIVERSITY: '/university/dashboard',
  UNIVERSITY_COURSES: '/university/courses',
  UNIVERSITY_CERTIFICATES: '/university/certificates',
  UNIVERSITY_COURSES_VIEW: '/university/courses/:courseId',
  UNIVERSITY_COURSES_CONTENT: '/university/courses/:courseId/content/:contentId',
  UNIVERSITY_COURSES_ENROLL: '/university/courses/:courseId/enroll',
  UNIVERSITY_COURSES_UNENROLL: '/university/courses/:courseId/unenroll',
  STUDENT_DASHBOARD: '/dashboard',

  CRM: '/crm/dashboard',
  CRM_OVERVIEW: '/crm/overview',
  CRM_FUNNEL_SETTINGS: '/crm/funnel-settings',
  LEADS: '/crm/leads',
  LEADS_VIEW: '/crm/leads/:leadId',
  CAMPAIGN_LINKS: '/crm/campaign-links',

  // Fallback
  NOT_FOUND: '*',
} as const;